
<div class="stripe-transaction-complete jhm-modal-background">
  <div id="stripe-success-modal" class="jhm-modal">
    @if (loading) {
      <div>
        Loading...
      </div>
    }
    @if (!loading) {
      <div>
        @if (transaction?.status === 'success') {
          <div class="success">
            <div class="cart-and-exit">
              <div class="cart-circle">
                <img class="cart" src="./assets/images/cart-circle-check.svg">
              </div>
              <img class="exit" src="./assets/images/black-x.svg" (click)="closeModalClicked()">
            </div>
            <div class="summary">
              You purchased <span class="credits">{{transaction.creditAmount | centsToDollars}} in credit</span> for <span class="cost">${{transaction.creditCost + transaction.taxCost | number : '1.2-2'}}</span> on {{getDateSecondsSinceEpoch(transaction.createdInstantMillisFromEpoch)}}.
            </div>
            <div class="horizontal-line line"></div>
            <div class="line-item">
              <div>
                Order Number
              </div>
              <div class="line-item-value">
                {{transaction.orderNumber}}
              </div>
            </div>
            <div class="horizontal-line line"></div>
            <div class="line-item">
              <div>
                {{transaction.creditAmount | centsToDollars}} in credit
              </div>
              <div>
                {{transaction.creditCost | number : '1.2-2'}}
              </div>
            </div>
            <div class="line-item">
              <div>
                Tax
              </div>
              <div>
                {{transaction.taxCost | number : '1.2-2'}}
              </div>
            </div>
            <div class="horizontal-line line"></div>
            <div class="line-item">
              <div>
                Total
              </div>
              <div>
                {{transaction.creditCost + transaction.taxCost | number : '1.2-2'}}
              </div>
            </div>
          </div>
        }
        @if (status === 'cancel') {
          <div>
            <img class="exit" src="./assets/images/black-x.svg" (click)="closeModalClicked()">
            Canceled
          </div>
        }
      </div>
    }
  </div>
</div>